import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateLobby.css';
import Button from '../ui/Button';
import { createLobby } from '../../firebase/services';
import { useGame } from '../../contexts/GameContext';

const CreateLobby = ({ onBack }) => {
  const [playerName, setPlayerName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { setPlayerId, setPlayerName: setContextPlayerName, setLobbyCode } = useGame();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!playerName.trim()) {
      setError('Lütfen bir isim girin');
      return;
    }
    
    // Clear any previous errors
    setError('');
    setIsLoading(true);
    
    try {
      // Create lobby with player as host
      const { lobbyCode, playerId } = await createLobby(playerName);
      
      // Update game context
      setPlayerId(playerId);
      setContextPlayerName(playerName);
      setLobbyCode(lobbyCode);
      
      // Navigate to the lobby page with the new lobby code
      navigate(`/lobby/${lobbyCode}`);
      console.log(`Lobi başarıyla oluşturuldu, yönlendiriliyor: /lobby/${lobbyCode}`);
    } catch (error) {
      console.error("Lobi oluşturulurken hata:", error);
      setError('Lobi oluşturulamadı. Lütfen tekrar deneyin.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="create-lobby">
      <h2 className="create-lobby__title">Yeni Lobi Oluştur</h2>
      
      <form onSubmit={handleSubmit} className="create-lobby__form">
        <div className="create-lobby__input-group">
          <label htmlFor="playerName" className="create-lobby__label">İsminiz</label>
          <input
            type="text"
            id="playerName"
            className="create-lobby__input"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            placeholder="İsminizi girin"
            maxLength={15}
            autoComplete="off"
            disabled={isLoading}
          />
        </div>
        
        {error && <div className="create-lobby__error">{error}</div>}
        
        <div className="create-lobby__buttons">
          <Button 
            onClick={onBack} 
            variant="secondary" 
            disabled={isLoading}
          >
            Geri
          </Button>
          <Button 
            type="submit" 
            disabled={isLoading || !playerName.trim()}
          >
            {isLoading ? 'Oluşturuluyor...' : 'Lobi Oluştur'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateLobby;
